module.exports = __webpack_public_path__ + "static/media/DecSelfie.catalyst.da529b93.tsx";